import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import UiButton from "../../Common/UiButton/UiButton";
import "../../PartnerManagement/AddPartner/Style.css";
import { Col, Row } from "react-bootstrap";
import TextInput from "../../Common/UITextInput/TextInput";
import { Form, Drawer, message, notification } from "antd";
import UiDropDown from "../../Common/UiDropDown/UiDropDown";
import useForm from "../../../common/hooks/useForm";
import {
  getAddEmployeeDetail,
  getEmployeeDetails,
  saveAddEmployeeDetails,
} from "../../../redux/AddEmployee/action";
import { connect } from "react-redux";
import { getMasterBranchDataDetails } from "../../../redux/BranchPrefernces/action";
import useSession from "../../CustomLogout/useSession";
const ViewUserEditDetails = ({
  setPartnerRefresh,
  partnerRefresh,
  drawerOpen,
  setDrawerOpen,
  ...props
}) => {
  const tab = useSelector((state) => state?.accessManagement?.tab);
  const userTab = useSelector((state) => state?.userListingReducer?.tab);

  const handleSessionExpired = useSession();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const { state, onChangeTextHandler, setState } = useForm();
  const [branchDtoList, setBranchDtoList] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [data, setData] = useState({});
  const [btnDisable, setBtnDisable] = useState(false);

  const [branchName, setBranchName] = useState("");

  const showDrawer = () => {
    setOpenEdit(true);
    setDrawerOpen(true);
  };

  const onClose = () => {
    setOpenEdit(false);
    setDrawerOpen(false);
    form.resetFields();
    setBtnDisable(false);
  };

  useEffect(() => {
    if (drawerOpen) {
      props
        .getMasterBranchDataDetails({
          access_token: props.access_token,
        })
        .then((res) => {
          setBranchDtoList(res?.data?.dtoList);
          if (res?.data?.error || res?.message) {
            const errorCode = res?.data?.error?.errorCode || res?.errorCode;
            const errorMessage = res?.data?.error?.message || res?.message;
            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    }
  }, [drawerOpen]);
  useEffect(() => {
    const fetchData = async () => {
      //Returned from here, as now it's not needed or required, in case in future if you need this please feel free to activate it.
      try {
        const id = props.row?.original?.userId;
        const effectiveStatus = tab || userTab;
        console.log("objecteffectiveStatus", effectiveStatus, tab, userTab);
        if (!id) return; // If id is not available, return early.

        if (!["ACTIVE", "NEVER_LOGGED_IN"].includes(effectiveStatus)) return;

        console.log("Landed Landed33333", tab, userTab);
        const response = await props.getEmployeeDetails({
          accessToken: props.access_token,
          userId: id,
        });

        if (response.status === 200) {
          setData(response.data?.dto);

          const branch =
            response?.data?.dto?.avanseBranches &&
            Array.isArray(response.data.dto.avanseBranches) &&
            response.data.dto.avanseBranches.length > 0
              ? {
                  label: response.data.dto.avanseBranches[0].branchName,
                  value: response.data.dto.avanseBranches[0].branchId,
                }
              : undefined;

          form.setFieldsValue({
            employeeCode: response.data?.dto?.employeeCode,
            email: response.data?.dto?.emailAddress,
            employeeFirstName: response?.data?.dto?.userFirstName,
            employeeLastName: response?.data?.dto?.userLastName,
            ldapId: response.data?.dto?.ldapId,
            roleType: {
              label: response.data?.dto?.roleType,
              value: response.data?.dto?.roleId,
            },
            BranchName: branch,
          });
          setBranchName(response?.data?.dto?.avanseBranches[0]?.branchName);
        } else {
          if (response?.data?.error || response?.message) {
            const errorCode =
              response?.data?.error?.errorCode || response?.errorCode;
            const errorMessage =
              response?.data?.error?.message || response?.message;
            if (errorCode === "403" && response?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      } catch (error) {
        console.log("line116", error);
      }
    };

    fetchData();
  }, [
    props.row?.original?.userId,
    props.access_token,
    props.getEmployeeDetails,
    drawerOpen,
  ]);

  const roleTypeList =
    props.addEmployeeData?.getAddEmployee?.length > 0
      ? props.addEmployeeData?.getAddEmployee.map((el) => {
          return {
            label: el.role,
            value: el.id,
          };
        })
      : [];

  const employeeCode = data?.employeeCode;
  const emailAddress = data?.emailAddress;

  const userFirstName = data?.userFullName;
  const ldapId = data?.ldapId;
  const roleType = data?.roleType;

  const handleChange = (data) => {
    setBtnDisable(true);
    const addEmployeedataSave = {
      userId: props.row?.original?.userId,
      employeeCode: data?.employeeCode,
      roleType: {
        id: data?.roleType?.value,
        role: data?.roleType?.label,
      },
      userFirstName: data.employeeFirstName?.trim(),
      userLastName: data.employeeLastName?.trim(),
      emailAddress: data.email?.trim(),
      avanseBranchIds: [data?.BranchName?.value],
      ldapId: data.ldapId?.trim(),
    };

    props
      .saveAddEmployeeDetails({
        values: addEmployeedataSave,
        access_token: props.access_token,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Edited Employee Successfully");
          setBtnDisable(false);
          setOpenEdit(false);
          form.resetFields();
          setDrawerOpen(false);
          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setBtnDisable(false);
          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };
  let branchOptions =
    branchDtoList?.length > 0
      ? branchDtoList.map((el) => {
          return {
            label: el?.branchName,
            value: el?.branchId,
          };
        })
      : "";

  // let branchOptions = branchDtoList?length > 0 ? branchDtoList.map((el) => {
  //   return {
  //     label: el?.branchName,
  //     value: el?.branchId,
  //   };
  // }):"";
  return (
    <div className="addpartner-section" id="add-employee-sec">
      {/* <p
        style={{ cursor: "pointer", color: "#00b1b1" }}
        onClick={() => {
          showDrawer();
          props.hide && props.hide();
        }}
      >
        View/ Edit Detail
      </p> */}
      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={drawerOpen}
        className="add-partner-dow"
      >
        <Form
          autoComplete="off"
          form={form}
          name="addEmployee"
          onFinish={handleChange}
        >
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-content-partner"
            >
              <Col md={6} className="addpartnerheading">
                <h2 className="main-heading">Edit Employee</h2>
                <div className="headre-line"></div>
              </Col>
              <Col md={6} className="btn-section">
                <h2 onClick={onClose} className="cancel-btn-add">
                  cancel
                </h2>
                {/* <UiButton type="submit" title="Create Employee" /> */}
              </Col>
            </Col>
          </Row>

          <h4>EMPLOYEE INFO</h4>
          <Row className="form-group">
            <Col md={7} className="signatory-label-group">
              <p className="label">EMPLOYEE CODE</p>
              <p className="value">{employeeCode ? employeeCode : "------"}</p>
            </Col>
            <Col md={4} className="signatory-label-group">
              <p className="label">EMPLOYEE NAME</p>
              <p className="value">
                {userFirstName ? userFirstName : "------"}
              </p>
            </Col>
          </Row>

          <Row className="form-group">
            <Col md={7} className="signatory-label-group">
              <p className="label">EMPLOYEE EMAIL</p>
              <p className="value name-sec">
                {emailAddress ? emailAddress : "------"}
              </p>
            </Col>
            <Col md={4} className="signatory-label-group">
              <p className="label">LDAP ID</p>
              <p className="value">{ldapId ? ldapId : "------"}</p>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md={7} className="signatory-label-group">
              <p className="label">ROLE IN PARTNER PORTAL</p>
              <p className="value name-sec">{roleType ? roleType : "------"}</p>
            </Col>
            <Col md={4} className="signatory-label-group">
              <p className="label">Avanse Branch Name</p>
              <p className="value name-sec">{branchName}</p>
            </Col>
          </Row>

          <h3 className="sub-text">Employee Info</h3>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col md={4}>
                <FormItem
                  name="employeeCode"
                  label="employee Code"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Employee Code",
                    },
                  ]}
                >
                  <TextInput
                    name="employeeCode"
                    onChange={onChangeTextHandler}
                    type="number"
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[0-9-+]*$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                  />
                </FormItem>
              </Col>
              <Col md={4} className="mob-sec-eF">
                <FormItem
                  name="employeeFirstName"
                  label="Employee First Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Employee First Name",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[a-zA-Z]+$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                    name="employeeFirstName"
                    value={state.employeeFirstName}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={4} className="mob-sec-eF">
                <FormItem
                  name="employeeLastName"
                  label="Employee Last Name"
                  onInput={(e) => {
                    if (e.target.value.trim() == "") {
                      e.target.value = e.target.value.trim();
                    }

                    if (e.target.value.trim() !== "") {
                      e.target.value = new RegExp("^[a-zA-Z]+$").test(
                        e.target.value
                      )
                        ? e.target.value?.trimStart()
                        : e.target.value
                            ?.trimStart()
                            ?.substring(0, e.target.value.length - 1);
                    }
                  }}
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Employee Last Name",
                    },
                  ]}
                >
                  <TextInput
                    value={state.employeeLastName}
                    onChange={onChangeTextHandler}
                    type="text"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner"
            >
              <Col md={4}>
                <FormItem
                  name="email"
                  label="Email Address"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Email Required!",
                    },
                  ]}
                >
                  <TextInput
                    maxLength={255}
                    type="email"
                    name="email"
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = e.target.value.trimStart();
                      }
                    }}
                    validation={[
                      {
                        type: "email",
                        message: "Invalid Email!",
                      },
                    ]}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={4} className="mob-sec-eF">
                <FormItem
                  name="ldapId"
                  label="ldap Id"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter ldap Id",
                    },
                  ]}
                >
                  <TextInput
                    value={state.ldapId}
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = e.target.value.trimStart();
                      }
                    }}
                    onChange={onChangeTextHandler}
                    type="text"
                  />
                </FormItem>
              </Col>

              <Col md={4} className="select-roleTye-mob ">
                <FormItem
                  name="BranchName"
                  label="Branch Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Role",
                    },
                  ]}
                >
                  <UiDropDown
                    className="new-role-sec"
                    data={branchOptions}
                    placeholder="Select"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <h3 className="sub-text">Role Info</h3>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-fields-partner mob-sec-role"
            >
              <Col md={12} className="select-roleTye-mob ">
                <FormItem
                  name="roleType"
                  label="Role In Partner Portal"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Role",
                    },
                  ]}
                >
                  <UiDropDown
                    className="new-role-sec"
                    data={roleTypeList}
                    placeholder="Select"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner last-btn-sec-changes"
            >
              <Col md={12}>
                <UiButton
                  disabled={btnDisable}
                  type="submit"
                  title="Edit Employee"
                  className="primary-btn"
                />
              </Col>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    addEmployeeData: state.addEmployeeData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAddEmployeeDetail: (accessToken) =>
      dispatch(getAddEmployeeDetail(accessToken)),
    saveAddEmployeeDetails: (data) => dispatch(saveAddEmployeeDetails(data)),
    getMasterBranchDataDetails: (data) =>
      dispatch(getMasterBranchDataDetails(data)),
    getEmployeeDetails: (data) => dispatch(getEmployeeDetails(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewUserEditDetails);
